/* eslint-disable max-lines */
import React, { useState, useEffect } from "react";
import dayjs from "dayjs";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
// Attempt to import user refresh action if it exists
// If getUsersByID does not exist in your slice, remove or adjust this import.
import { getUsersByID, getWheelPoint } from "../../store/slices/user"; // adjust if path differs

const API_BASE_URL = (
  process.env.REACT_APP_API_BASE_URL || "https://api.bucket-001.online"
).replace(/\/+$/, "");
const ICON_READY = "/lux/icons/rail-diamond.webp";
const ICON_WAITING = "/lux/icons/rail-wait.webp";

const SuccessToast = ({ message, show, onClose }) => {
  useEffect(() => {
    if (!show) return;
    const timer = setTimeout(onClose, 4000);
    return () => clearTimeout(timer);
  }, [show, onClose]);

  if (!show) return null;

  return (
    <div
      style={{
        position: "fixed",
        left: "50%",
        bottom: "86px",
        transform: "translateX(-50%)",
        background:
          "linear-gradient(135deg, rgba(20, 45, 34, 0.95) 0%, rgba(12, 34, 24, 0.95) 100%)",
        border: "1px solid rgba(110, 231, 183, 0.45)",
        borderRadius: "14px",
        padding: "12px 14px",
        width: "min(92vw, 420px)",
        boxShadow:
          "0 14px 34px rgba(0, 0, 0, 0.45), 0 0 20px rgba(16, 185, 129, 0.24)",
        zIndex: 10000,
        animation: "toastPopIn 0.25s ease-out",
        display: "flex",
        alignItems: "center",
        gap: "10px",
      }}
    >
      <div
        style={{
          width: 34,
          height: 34,
          borderRadius: 10,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "linear-gradient(135deg, #34d399 0%, #10b981 100%)",
          color: "#062e22",
          fontSize: 18,
          fontWeight: 900,
          flexShrink: 0,
        }}
      >
        💎
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div
          style={{
            color: "#a7f3d0",
            fontSize: 11,
            fontWeight: 700,
            letterSpacing: 0.3,
            textTransform: "uppercase",
            marginBottom: 1,
          }}
        >
          รับรางวัลสำเร็จ
        </div>
        <div style={{ color: "#ecfdf5", fontWeight: 700, fontSize: 14 }}>
          {message}
        </div>
      </div>
      <button
        onClick={onClose}
        style={{
          background: "none",
          border: "1px solid rgba(167, 243, 208, 0.28)",
          fontSize: "18px",
          cursor: "pointer",
          color: "#d1fae5",
          padding: 0,
          marginLeft: "4px",
          borderRadius: "9px",
          width: "28px",
          height: "28px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          transition: "all 0.2s ease",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = "rgba(110, 231, 183, 0.14)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = "transparent";
        }}
      >
        ×
      </button>
      <style>
        {`
          @keyframes toastPopIn {
            from {
              transform: translateX(-50%) translateY(12px) scale(0.98);
              opacity: 0;
            }
            to {
              transform: translateX(-50%) translateY(0) scale(1);
              opacity: 1;
            }
          }
        `}
      </style>
    </div>
  );
};

const CounterBonus = () => {
  const dispatch = useDispatch();
  const { singleUsers } = useSelector((state) => state.user || {});
  const user = singleUsers && singleUsers.length ? singleUsers[0] : null;

  const [timeLeft, setTimeLeft] = useState("00:00:00");
  const [activeIcon, setActiveIcon] = useState(ICON_READY);
  const [enableClick, setEnableClick] = useState(false);
  const [toast, setToast] = useState({ show: false, message: "" });

  const showSuccessToast = (message) => setToast({ show: true, message });
  const hideToast = () => setToast({ show: false, message: "" });

  // Receive reward
  const handleReceive = async () => {
    if (!enableClick || !user?.id) return;
    setEnableClick(false);
    try {
      const res = await axios.post(
        `${API_BASE_URL}/countdownbox/receive/${user.id}`,
      );
      if (res?.data?.message === "Diamond Point Added Success") {
        // Refresh user data if action exists
        if (typeof getUsersByID === "function") {
          try {
            dispatch(getUsersByID(user));
            dispatch(getWheelPoint(user));
          } catch (_) {}
        }
        showSuccessToast("รับเพชรฟรีเรียบร้อยแล้ว");
      } else {
        alert("ไม่สามารถรับเพชรได้กรุณาติดต่อแอดมิน");
      }
    } catch (e) {
      console.error(e);
      alert("ไม่สามารถรับเพชรได้กรุณาติดต่อแอดมิน");
    }
  };

  // Countdown logic
  useEffect(() => {
    if (!user?.countdown_end) {
      setTimeLeft("00:00:00");
      setEnableClick(false);
      setActiveIcon(ICON_READY);
      return;
    }

    const end = dayjs(user.countdown_end);
    if (!end.isValid()) {
      setTimeLeft("00:00:00");
      setEnableClick(false);
      setActiveIcon(ICON_READY);
      return;
    }

    const update = () => {
      const now = dayjs();
      const diff = end.diff(now);
      if (diff <= 0) {
        setTimeLeft("00:00:00");
        setEnableClick(true);
        setActiveIcon(ICON_READY);
        return;
      }
      // manual diff breakdown instead of dayjs.duration
      const totalSeconds = Math.floor(diff / 1000);
      const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
      const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(
        2,
        "0",
      );
      const seconds = String(totalSeconds % 60).padStart(2, "0");
      setTimeLeft(`${hours}:${minutes}:${seconds}`);
      setEnableClick(false);
      setActiveIcon(ICON_WAITING);
    };

    update();
    const interval = setInterval(update, 1000);
    return () => clearInterval(interval);
  }, [user]);

  // Hidden if no user
  if (!user) return null;

  return (
    <>
      <button
        type="button"
        className={`lux-rail__item ${enableClick ? "lux-rail__item--ready" : ""}`}
        onClick={handleReceive}
        disabled={!enableClick}
        aria-label="รับกล่องเพชร"
      >
        {enableClick && <span className="lux-rail__dot" />}
        <span className="lux-rail__icon">
          <img src={activeIcon} alt="" draggable={false} />
        </span>
        <span className="lux-rail__label">กล่องเพชร</span>
        <span className="lux-rail__meta">
          {enableClick ? "รับได้แล้ว" : timeLeft}
        </span>
      </button>
      <SuccessToast
        message={toast.message}
        show={toast.show}
        onClose={hideToast}
      />
    </>
  );
};

export default CounterBonus;
